/**
 * Route-level error boundary rendered by React Router's `errorElement`.
 * Without this, any synchronous throw while a route mounts (e.g. a broken
 * editor/chart) bubbles to React Router's default "Unexpected Application
 * Error!" screen and takes down the whole app shell.
 * @module routes/RouteErrorBoundary
 */

import { Result, Button } from 'antd'
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'

export function RouteErrorBoundary() {
  const error = useRouteError()

  // Surface for observability; route errors are otherwise swallowed by Router.
  console.error('[RouteErrorBoundary] Caught route error:', error)

  let title = 'Đã xảy ra lỗi'
  let subTitle =
    'Xin lỗi, trang này gặp lỗi không mong muốn. Vui lòng tải lại hoặc quay về trang chủ.'

  if (isRouteErrorResponse(error)) {
    title = `${error.status} - ${error.statusText || 'Lỗi'}`
    subTitle = 'Không thể tải trang được yêu cầu.'
  }

  return (
    <div style={{ padding: '50px' }}>
      <Result
        status="error"
        title={title}
        subTitle={subTitle}
        extra={[
          <Button
            type="primary"
            key="reload"
            onClick={() => window.location.reload()}
          >
            Tải lại trang
          </Button>,
          <Button
            key="home"
            onClick={() => {
              window.location.href = '/'
            }}
          >
            Về trang chủ
          </Button>,
        ]}
      />
    </div>
  )
}

export default RouteErrorBoundary
